export default __webpack_public_path__ + "static/headingMobile-009218de0253cb8d8bdd556a10ad0eaa.svg";